// extracted by mini-css-extract-plugin
module.exports = {"fill-politico-red":"_1SoZs641J1M26Hn_M4i08x"};